import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const horizontalDividerFn = /* @__PURE__ */ createRecipe('horizontal-divider', {}, [])

const horizontalDividerVariantMap = {}

const horizontalDividerVariantKeys = Object.keys(horizontalDividerVariantMap)

export const horizontalDivider = /* @__PURE__ */ Object.assign(memo(horizontalDividerFn.recipeFn), {
  __recipe__: true,
  __name__: 'horizontalDivider',
  __getCompoundVariantCss__: horizontalDividerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: horizontalDividerVariantKeys,
  variantMap: horizontalDividerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, horizontalDividerVariantKeys)
  },
  getVariantProps: horizontalDividerFn.getVariantProps,
})